export default {
      id: "health-insurance-usage",
      viewBox: "0 0 27 33",
      url: __webpack_public_path__ + "sprite.svg#health-insurance",
      toString: function () {
        return this.url;
      }
    }